module.exports = __webpack_public_path__ + "img/DefaultFeedbackPoor.4b9d678a.png";